import Shader from './Shader';
import * as Uniform from '../Uniform';
import FRAG_GAMEBOY from './Fragment/gameboy.frag';

export default class GameboyShader extends Shader {
	public frag = ():string => FRAG_GAMEBOY;
}